<template>
    <component v-bind:is="icon.Component" v-bind="icon.Args"/>
</template>

<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import {HeaderIcon, IconType} from "../GenericTableHeader";
import {LinkUtils} from "@/components/commons/Utils";

@Component({})
export default class GenericTableIconCell extends Vue {
    /** Valeur */
    @Prop({default: () => ''})
    public Value!: string;

    @Prop()
    public Header!: HeaderIcon;

    private icon: IIcon;

    created() {
        this.icon = new Icons[this.Header.IconType](this.Value);
    }
}

interface IIcon {
    Type: string;
    Component: string;
    Args: { [key: string]: any }
    Value: string
}

class Icon implements IIcon {
    private _type: string;
    private _component: string;
    private _args: { [key: string]: any };
    private _value: string;

    constructor(type: string, datas: Partial<Icon>) {
        this._type = type;
        this._component = datas?.Component ?? "";
        this._args = datas?.Args ?? [];
        this._value = datas?.Value ?? undefined;
    }

    public get Type(): string {
        return this._type;
    }

    public set Type(value: string) {
        this._type = value;
    }

    public get Component(): string {
        return this._component;
    }

    public set Component(value: string) {
        this._component = value;
    }

    public get Args(): { [p: string]: any } {
        return this._args;
    }

    public set Args(value: { [p: string]: any }) {
        this._args = value;
    }

    public get Value(): string {
        return this._value;
    }

    public set Value(value: string) {
        this._value = value;
    }
}

class PathIcon extends Icon {
    constructor(value: string) {
        let link: LinkUtils = new LinkUtils();
        super(IconType.Path, {
            Value: value,
            Component: 'b-img',
            Args: {
                'src': link.AbsoluteLink('Icons/' + value + '_Icon.svg'),
                'height': '20rem', 'width': '20rem'
            }
        });
    }
}

const Icons: { [key: string]: new (value) => Icon } = {
    Path: PathIcon,
}

</script>
<style scoped>

</style>